// Mutations enums
export enum MutationTypes {
  SET_DARK_MODE = 'SET_DARK_MODE',
}
